import airspace from './airspace'
import airway from './airway'

export default {
  airspace,
  airway
}
